import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import api from '@/api';
import { toast } from '@/lib/toast';
import { ref, reactive, onBeforeMount } from 'vue';
import RemoteTableModel from '@/components/RemoteTableModel';
import LogInfoWindow from "@/components/LogInfo.vue";
import LogEventsGrid from '@/components/eventsLogs/LogEventsGrid.vue';
import LogEventsFilter from '@/components/eventsLogs/LogEventsFilter.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'LogEvents',
  setup(__props) {

const confirm = ref({});
const eventList = ref([]);

const pageSizesList = ref([
  {title: '15', value: 15},
  {title: '50', value: 50},
  {title: '100', value: 100},
  {title: '500', value: 500},
]);

const tableModel = reactive(
  new RemoteTableModel({
    headers: [
      { title: 'ID события', key: 'id', sortable: false },
      { title: 'Дата и время', key: 'createdAt', sortable: true },
      { title: 'Действие', key: 'eventName', sortable: false },
      { title: 'Пользователь-субъект', key: 'madeByUsername', sortable: false },
      { title: 'Статус', key: 'success', sortable: false },
      { title: '', key: 'actions', sortable: false },
    ],
    loader(query) {
      const queryParams = {
        ...query.searchParams,
        ...query.range,
      };

      if (query.sort && query.sort.length > 0) {
        query.sort.forEach(({ column, order }) => {
          queryParams[`order[${column}]`] = order.toLowerCase();
        });
      }

      return api.get('/api/event', queryParams);
    },
    options: {
       sortBy: [
          { key: 'createdAt', order: 'desc' }
        ],
      isApiRequest: true,
      itemsPerPage: 15,
    },
  })
);

const loadEventList = async () => {
  try {
    const { results } = await api.get('/api/vocab/event');
    eventList.value = results;
  } catch (e) {
    toast.error(e.message);
  }
};

onBeforeMount(() => {
  loadEventList();
});

return (_ctx: any,_cache: any) => {
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_container = _resolveComponent("v-container")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(LogInfoWindow, {
      ref_key: "confirm",
      ref: confirm
    }, null, 512 /* NEED_PATCH */),
    _createVNode(_component_v_container, {
      class: "w-auto mx-15",
      fluid: ""
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_row, { class: "justify-space-between mb-6" }, {
          default: _withCtx(() => [
            _createVNode(LogEventsFilter, {
              "table-model": tableModel,
              "event-list": eventList.value
            }, null, 8 /* PROPS */, ["table-model", "event-list"])
          ]),
          _: 1 /* STABLE */
        }),
        _createVNode(_component_v_row, null, {
          default: _withCtx(() => [
            _createVNode(LogEventsGrid, {
              "page-sizes-list": pageSizesList.value,
              "table-model": tableModel,
              "confirm-dlg": confirm.value
            }, null, 8 /* PROPS */, ["page-sizes-list", "table-model", "confirm-dlg"])
          ]),
          _: 1 /* STABLE */
        })
      ]),
      _: 1 /* STABLE */
    })
  ], 64 /* STABLE_FRAGMENT */))
}
}

})